<template>
  <v-app>
    <main-app-bar elevation="2" app-bar-color="" app-bar-text-color="">
    </main-app-bar>
    <v-main class="mainDiv" v-bind:style="{ 'background-image': 'url(' + baseImg + ')' }">
      <div style="position: absolute; top: 65px; left: 0; right: 0; bottom: 10px; overflow-y: scroll">
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col class="mx-auto" >
              <v-card class="mx-auto" min-width="200" max-width="600">
                <v-img
                    color="surface-variant"
                    min-height="100"
                    max-height="500"
                    style="object-fit: scale-down;"
                    :src=machine
                >
                </v-img>

              </v-card>
            </v-col>
            <v-col>
              <v-card style="background-color: #ffffffa0">
                <div style="text-align: left" class="ma-3">
                  <p class="text-h5 playFairFont">
                    Üdvözöljük oldalunkon, örülünk, hogy ellátogatott hozzánk! <br>
                    Vállalkozásunk fő profilja a gépi hímzett termékek árusítása , legyen az ruha, táska, párna, sapka,<br>
                    törölköző!<br>
                    A hímzett termékek, nem csak egyediek, szépek és elegánsak, de divatosak is egyben. Ünnepre,
                    eseményre,<br>
                    ajándékként, vagy személyes használatra. A gépi hímzés előnye más technológiával szemben, hogy tartós,
                    nem<br>
                    fakul ki, nem kopik le.<br>
                    Egyedi elképzelése van? Abban is tudunk segíteni!<br>
                    <br>

                  </p>
                </div>

              </v-card>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col lg="8" xs="12">
              <v-card style="background-color: #ffffffa0">
                <p class="text-h5 mt-10 queensFont" style="text-align: center">
                  Keressen minket elérhetőségeink egyikén:<br>
                </p>
                <connection-row></connection-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>

    </v-main>
  </v-app>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {useDisplay} from "vuetify";
import MainAppBar from "@/components/MainAppBar.vue";
import ConnectionRow from "@/components/ConnectionRow.vue";

@Options({
  components: {ConnectionRow, MainAppBar},
  data() {
    return {
      drawer: false,
      machine: require("@/assets/company.png"),
      baseImg: require("@/assets/base.png"),
    };
  },
  computed: {
    imageHeight() {

      if (this.screenNames) {
        switch (this.screenNames.value) {
          case "xs":
            return 220 + "px";
          case "sm":
            return 400 + "px";
          case "md":
            return 500 + "px";
          case "lg":
            return 500 + "px";
          case "xl":
            return 500 + "px";
          case "xxl":
            return 500 + "px";
        }
      } else {
        const {name} = useDisplay();
        this.screenNames = name;
      }
      return 200;
    }
  },
  methods: {
    onConnectionClick(): void {
      this.$router.push("connection");
    },
    onGoToFacebookClick(): void {
      window.location.href = 'https://www.facebook.com/kreativhimzokucko';
    },
    addToClipboard(text: string): void {
      if (!navigator.clipboard) {
        this.snackbar = true;
        this.snackbarText = "Nem sikerült a vágólapra másolás! Nem biztonságos kapcsolat"
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.snackbar = true;
        this.snackbarText = "Vágólapra másolva!"
      }, (err) => {
        this.snackbar = true;
        this.snackbarText = "Nem sikerült a vágólapra másolás! " + err.message
      });
    }
  }

})
export default class AboutCompany extends Vue {

}
</script>


<style scoped>
.playFairFont {
  font-family: 'Playfair Display', serif
}
.queensFont {
  font-family: 'Quintessential', cursive;
}
.mainDiv {
  background-repeat: no-repeat;
  /*background-attachment: fixed;*/
  background-size: cover;
  background-position: 20% 20%;
}
</style>